<header class="header js-header" [class.bg-white]="!isHomePage" [class.shadow-1]="!isHomePage" [class.navbar-hidden]="isHomePage && isScrolled" [class.mobile-menu-open]="isMobileMenuOpen" data-x="header" data-x-toggle="is-menu-opened">
  <div class="header__container px-30 sm:px-20">
    <div class="d-flex items-center justify-between">

      <!-- Logo + Telefon - Sol -->
      <div class="d-flex items-center">
        <a routerLink="/" class="header-logo">
          <img src="assets/pusula/logo-text.png" alt="Pusula Tatil" style="height: 50px; width: auto; object-fit: contain;">
        </a>
        <span class="navbar-divider xl:d-none"></span>
        <a href="tel:+902422120224" class="navbar-phone xl:d-none">
          <span class="navbar-phone__icon">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.37 1.9.72 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.35 1.85.59 2.81.72A2 2 0 0 1 22 16.92z"/></svg>
          </span>
          <span class="navbar-phone__num">0242 212 02 24</span>
        </a>
      </div>

      <!-- Giriş Yap - Sağ -->
      <div class="d-flex items-center">
        <!-- Desktop Auth Actions (hide on mobile) -->
        <div class="d-flex xl:d-none items-center is-menu-opened-hide">
          <button type="button" class="navbar-cta mr-15" (click)="openCallbackModal()">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.37 1.9.72 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.35 1.85.59 2.81.72A2 2 0 0 1 22 16.92z"/></svg>
            <span>Sizi Arayalım</span>
          </button>
          <ng-container *ngIf="!isAuthenticated">
            <a routerLink="/login" class="navbar-auth">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
              <span>Giriş Yap <em>·</em> Kayıt Ol</span>
            </a>
          </ng-container>
          <ng-container *ngIf="isAuthenticated">
            <div class="user-dropdown" (click)="$event.stopPropagation()">
              <button type="button" class="user-dropdown__trigger" (click)="toggleUserDropdown()">
                <span class="user-avatar">{{ getUserInitial() }}</span>
                <span class="user-name">{{ userDisplayName }}</span>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" [style.transform]="isUserDropdownOpen ? 'rotate(180deg)' : ''"><polyline points="6 9 12 15 18 9"></polyline></svg>
              </button>
              <div class="user-dropdown__menu" *ngIf="isUserDropdownOpen">
                <div class="user-dropdown__head">
                  <span class="user-avatar user-avatar--lg">{{ getUserInitial() }}</span>
                  <div>
                    <div class="fw-600 text-14">{{ userDisplayName }}</div>
                  </div>
                </div>
                <a routerLink="/hesabim" class="user-dropdown__item" (click)="closeUserDropdown()">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
                  Hesabım
                </a>
                <a routerLink="/hesabim" class="user-dropdown__item" (click)="closeUserDropdown()">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"></rect><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
                  Rezervasyonlarım
                </a>
                <div class="user-dropdown__divider"></div>
                <button type="button" class="user-dropdown__item user-dropdown__item--danger" (click)="closeUserDropdown(); logout()">
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
                  Çıkış Yap
                </button>
              </div>
            </div>
          </ng-container>
        </div>

        <!-- Mobile Icons (show only on mobile) -->
        <div class="d-none xl:d-flex items-center text-dark-1" data-x="header-mobile-icons">
          <button type="button" class="mobile-menu-btn" (click)="toggleMobileMenu()" aria-label="Menü">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><line x1="4" y1="7" x2="20" y2="7"/><line x1="4" y1="12" x2="20" y2="12"/><line x1="4" y1="17" x2="20" y2="17"/></svg>
          </button>
        </div>
      </div>

    </div>
  </div>
</header>

<!-- Mobil Menü Drawer -->
<div class="mobile-drawer" [class.is-open]="isMobileMenuOpen" (click)="closeMobileMenu()">
  <aside class="mobile-drawer__panel" (click)="$event.stopPropagation()">
    <div class="mobile-drawer__head">
      <a routerLink="/" (click)="closeMobileMenu()">
        <img src="assets/pusula/logo-text.png" alt="Pusula Tatil" class="mobile-drawer__logo">
      </a>
      <button type="button" class="mobile-drawer__close" (click)="closeMobileMenu()" aria-label="Kapat">
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
      </button>
    </div>

    <a href="tel:+902422120224" class="mobile-drawer__phone">
      <span class="mobile-drawer__phone-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.37 1.9.72 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.35 1.85.59 2.81.72A2 2 0 0 1 22 16.92z"/></svg>
      </span>
      <div>
        <small>Destek Hattımız</small>
        <strong>0242 212 02 24</strong>
      </div>
    </a>

    <button type="button" class="mobile-drawer__cta" (click)="closeMobileMenu(); openCallbackModal()">
      Sizi Arayalım
    </button>

    <nav class="mobile-drawer__nav">
      <a routerLink="/" (click)="closeMobileMenu()">Anasayfa</a>
      <a routerLink="/contact" (click)="closeMobileMenu()">İletişim</a>
      <a routerLink="/help-center" (click)="closeMobileMenu()">Yardım Merkezi</a>
      <a routerLink="/blog" (click)="closeMobileMenu()">Blog</a>
    </nav>

    <div class="mobile-drawer__auth">
      <ng-container *ngIf="!isAuthenticated">
        <a routerLink="/login" (click)="closeMobileMenu()" class="mobile-drawer__login">
          Giriş Yap · Kayıt Ol
        </a>
      </ng-container>
      <ng-container *ngIf="isAuthenticated">
        <div class="mobile-drawer__user">{{ userDisplayName }}</div>
        <button type="button" (click)="closeMobileMenu(); logout()" class="mobile-drawer__logout">Çıkış Yap</button>
      </ng-container>
    </div>
  </aside>
</div>

<!-- Sizi Arayalım Modal -->
<div class="callback-modal" *ngIf="callbackModalOpen" (click)="closeCallbackModal()">
  <div class="callback-modal__box" (click)="$event.stopPropagation()">
    <button type="button" class="callback-modal__close" (click)="closeCallbackModal()" aria-label="Kapat">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
    </button>
    <ng-container *ngIf="!callbackSuccess">
    <h3 class="callback-modal__title">Sizi Arayalım</h3>
    <p class="callback-modal__desc">Bilgilerinizi bırakın, en kısa sürede sizi arayalım.</p>
    <form class="callback-modal__form" (ngSubmit)="submitCallback()">
      <label class="cb-full">
        <span>Ad</span>
        <input type="text" name="name" [(ngModel)]="callbackName" placeholder="Adınız Soyadınız" required>
      </label>
      <div class="cb-row">
        <label>
          <span>E-Mail</span>
          <input type="email" name="email" [(ngModel)]="callbackEmail" placeholder="ornek@mail.com">
        </label>
        <label>
          <span>Telefon Numarası</span>
          <input type="tel" name="phone" [(ngModel)]="callbackPhone" placeholder="05xx xxx xx xx" required>
        </label>
      </div>
      <div class="cb-row">
        <label>
          <span>Arama Tarihi</span>
          <select name="date" [(ngModel)]="callbackDate">
            <option>Bugün</option>
            <option>Yarın</option>
            <option>Bu Hafta</option>
            <option>Farketmez</option>
          </select>
        </label>
        <label>
          <span>Arama Zamanı</span>
          <select name="time" [(ngModel)]="callbackTime">
            <option>Farketmez</option>
            <option>Sabah (09-12)</option>
            <option>Öğlen (12-15)</option>
            <option>Öğleden Sonra (15-18)</option>
            <option>Akşam (18-21)</option>
          </select>
        </label>
      </div>
      <label class="cb-full">
        <span>Notunuz</span>
        <textarea name="note" [(ngModel)]="callbackNote" rows="3" placeholder="Eklemek istediğiniz not..."></textarea>
      </label>
      <div class="callback-modal__error" *ngIf="callbackError">{{ callbackError }}</div>
      <button type="submit" class="callback-modal__submit" [disabled]="callbackSubmitting">
        <span *ngIf="!callbackSubmitting">Gönder</span>
        <span *ngIf="callbackSubmitting">Gönderiliyor...</span>
      </button>
    </form>
    </ng-container>

    <div class="callback-modal__success" *ngIf="callbackSuccess">
      <div class="callback-modal__success-icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
      </div>
      <h3 class="callback-modal__title">Talebiniz Alındı</h3>
      <p class="callback-modal__desc">En kısa sürede sizi arayacağız. Teşekkür ederiz!</p>
      <button type="button" class="callback-modal__submit" (click)="closeCallbackModal()">Tamam</button>
    </div>
  </div>
</div>

